import { useShowTutorApi } from '@api/tutor-kanban/show.hook'
import { useAgentsApi } from '@api/tutor-kanban/agents.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const tutorId = to.params.id as string

  void useShowTutorApi({ tutorId })
  void useAgentsApi()
})
